import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import VExportPaymentService from '../../../../Services/VExportPaymentService';
import VoidAndReissueParamsItem from '../../../../Domain/VoidAndReissueParamsItem';

export default class VoidAndSuppressWindowDescription {
  static titleForCreate = 'Void & Suppress';
  static titleForEdit = 'Void & Suppress';
  static finishButtonLabel = 'Void & Suppress';
  static itemType = VoidAndReissueParamsItem;
  static serviceFunction = (edited) => VExportPaymentService.VoidAndSuppress(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void & Suppress process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Reason', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
